var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33331 13.5199L25.9133 4.33325L47.6666 13.5199V38.4799L26.0866 47.7532L4.33331 38.4799V13.5199Z",
    fill: "#F99E2C",
    stroke: "#0F111C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 27.9131L52 41.2533L26 52L-5.81198e-06 41.2533L-3.18925e-06 10.7467L26 7.16057e-06L52 10.7467L52 27.9131ZM47.6667 23.92L47.6667 13.52L26 4.33334L4.33333 13.52L4.33333 23.92L20.4533 23.92L22.1867 18.5467L26.52 18.5467L21.4933 34.1467L17.16 34.1467L19.0667 28.2533L4.33333 28.2533L4.33333 38.48L26 47.6667L47.6667 38.48L47.6667 28.2533L31.5467 28.2533L29.64 34.1467L25.3067 34.1467L30.3333 18.5467L34.6667 18.5467L32.9333 23.92L47.6667 23.92Z",
    fill: "#0F111C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTticon);
export default __webpack_public_path__ + "static/media/tticon.f97956ed1a6fb54e03707cedd74a95fe.svg";
export { ForwardRef as ReactComponent };